"use client";

import { Layers, ArrowRight } from "lucide-react";
import { useTenant } from "@/lib/tenant";

interface PlatformHubBannerProps {
  className?: string;
}

/**
 * Banner shown at the top of the main hub (euro-pro-flaeche.de)
 * Explains that this is the central platform showing all offerings
 */
export function PlatformHubBanner({ className }: PlatformHubBannerProps) {
  const tenant = useTenant();

  if (!tenant.features.isPlatformHub) {
    return null;
  }

  return (
    <div className={`bg-gradient-to-r from-dark to-dark-green text-white ${className}`}>
      <div className="px-4 py-3 flex items-center justify-center gap-4">
        {/* Icon */}
        <div className="hidden sm:flex w-10 h-10 rounded-full bg-white/10 items-center justify-center">
          <Layers className="w-5 h-5" />
        </div>

        {/* Content */}
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
          <p className="text-sm text-center sm:text-left">
            <span className="font-semibold">Euro Pro Fläche</span>
            <span className="text-white/70 mx-2">–</span>
            <span className="text-white/90">Alle 5 Marktplätze auf einer Karte</span>
          </p>

          {/* CTA to scroll or learn more */}
          <a
            href="#marktplaetze"
            className="flex items-center gap-1 text-xs font-medium text-white/80 hover:text-white transition-colors"
          >
            Marktplätze erkunden
            <ArrowRight className="w-3 h-3" />
          </a>
        </div>
      </div>
    </div>
  );
}
